export function getLockedBadges(state) {
  return state.lockedBadges
}

export function getUnlockedBadges(state) {
  return state.unlockedBadges
}
